(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bamboo-crop-demo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.bceReady) return;
    root.dataset.bceReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rows = Array.prototype.slice.call(root.querySelectorAll('.bce__row'));
    if (!rows.length) return;

    // Click a plate -> fill the Beespoke size picker (no-op if no picker on the page)
    function normSize(s) { return (s || '').toLowerCase().replace(/\s+/g, '').replace(/×/g, 'x'); }
    function currentSel() { return document.querySelector('variant-picker select'); }
    function syncPicked() {
      var sel = currentSel(), cur = null;
      if (sel && sel.value !== '' && sel.selectedIndex >= 0 && sel.options[sel.selectedIndex]) cur = normSize(sel.options[sel.selectedIndex].textContent);
      rows.forEach(function (r) {
        var m = r.querySelector('.bce__media');
        if (m) m.classList.toggle('is-picked', !!cur && normSize(m.getAttribute('data-size')) === cur);
      });
    }
    function fillSize(label) {
      var sel = currentSel();
      if (!sel) return;
      var want = normSize(label), exact = null, partial = null;
      Array.prototype.forEach.call(sel.options, function (o) {
        var n = normSize(o.textContent);
        if (!n || !want) return;
        if (n === want) exact = o;
        else if (n.indexOf(want) !== -1) partial = o;
      });
      var matched = exact || partial;
      if (!matched) return;
      sel.value = matched.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      syncPicked();
    }
    rows.forEach(function (r) {
      var media = r.querySelector('.bce__media');
      if (!media) return;
      media.addEventListener('click', function () { fillSize(media.getAttribute('data-size')); });
      media.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fillSize(media.getAttribute('data-size')); } });
    });
    document.addEventListener('variant:update', syncPicked);
    setTimeout(syncPicked, 200);

    if (reduce) { rows.forEach(function (r) { r.classList.add('is-in'); }); return; }

    root.classList.add('bce--anim');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      rows.forEach(function (r) { io.observe(r); });
    } else { rows.forEach(function (r) { r.classList.add('is-in'); }); }

    var ticking = false;
    var mobile = window.matchMedia('(max-width: 749px)');
    function update() {
      ticking = false;
      if (mobile.matches) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      rows.forEach(function (r) {
        var rect = r.getBoundingClientRect();
        if (rect.bottom < -80 || rect.top > vh + 80) return;
        var prog = ((rect.top + rect.height / 2) - vh / 2) / vh;
        var media = r.querySelector('.bce__media');
        var text = r.querySelector('.bce__text');
        if (media) media.style.transform = 'translateY(' + (prog * 34).toFixed(1) + 'px)';
        if (text) text.style.transform = 'translateY(' + (prog * -62).toFixed(1) + 'px)';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }
  function boot() { document.querySelectorAll('.bce').forEach(setup); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bamboo-size-price-chart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.bspcReady) return;
    root.dataset.bspcReady = '1';
    var stage = root.querySelector('.bspc__stage');
    var cap = root.querySelector('.bspc__cap');
    if (!stage) return;
    var prints = root.querySelectorAll('.bspc__print');
    var pills = root.querySelectorAll('.bspc__sizepill');
    var cta = root.querySelector('.bspc__shopcta');
    var bespcta = root.querySelector('.bspc__bespcta');
    var syncPicker = root.getAttribute('data-sync') === 'true';
    var beespokeMode = root.getAttribute('data-beespoke') === 'true';
    function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, '').replace(/×/g, 'x'); }

    function setCaption(fig) {
      if (!fig) { cap.innerHTML = ''; return; }
      var price = fig.getAttribute('data-price');
      var besp = fig.getAttribute('data-besp');
      var html = '';
      if (beespokeMode) {
        if (besp) html = '<span class="bspc__caplbl">Beespoke</span> <strong>' + besp + '</strong>';
      } else {
        if (price) html += '<span class="bspc__caplbl">Prepared Prints</span> <strong>' + price + '</strong>';
        if (besp) html += (html ? ' <span class="bspc__capsep">·</span> ' : '') + '<span class="bspc__caplbl">Beespoke</span> <strong>' + besp + '</strong>';
      }
      cap.innerHTML = html;
    }

    function showSingle(id) {
      stage.setAttribute('data-mode', 'single');
      stage.setAttribute('data-active', id);
      var active = null;
      prints.forEach(function (p) {
        var on = p.getAttribute('data-id') === id;
        p.classList.toggle('is-active', on);
        if (on) active = p;
      });
      pills.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-value') === id); });
      setCaption(active);
      if (cta && active) { var u = active.getAttribute('data-url'); if (u) cta.setAttribute('href', u); }
      if (bespcta && active) { var bu = active.getAttribute('data-bespurl'); if (bu) bespcta.setAttribute('href', bu); }
    }

    function pushToPicker(fullLabel) {
      var sel = document.querySelector('variant-picker select');
      if (!sel) return;
      var want = norm(fullLabel), exact = null, partial = null;
      Array.prototype.forEach.call(sel.options, function (o) {
        var n = norm(o.textContent);
        if (!n || !want) return;
        if (n === want) exact = o; else if (n.indexOf(want) !== -1) partial = o;
      });
      var m = exact || partial;
      if (!m) return;
      sel.value = m.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function pullFromPicker() {
      var sel = document.querySelector('variant-picker select');
      if (!sel || sel.value === '' || sel.selectedIndex < 0 || !sel.options[sel.selectedIndex]) return;
      var lbl = norm(sel.options[sel.selectedIndex].textContent), match = null;
      pills.forEach(function (b) { if (norm(b.getAttribute('data-match')) === lbl) match = b; });
      if (match) showSingle(match.getAttribute('data-value'));
    }

    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        var keepY = window.pageYOffset || document.documentElement.scrollTop || 0;
        showSingle(b.getAttribute('data-value'));
        if (syncPicker) pushToPicker(b.getAttribute('data-match'));
        var n = 0;
        (function lockScroll() { window.scrollTo(0, keepY); if (n++ < 30) requestAnimationFrame(lockScroll); })();
      });
    });

    var toplink = root.querySelector('.bspc__toplink');
    if (toplink) {
      toplink.addEventListener('click', function () {
        var t = document.getElementById('beespoke-photo-name') || document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('variant-picker');
        if (t && t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    showSingle(stage.getAttribute('data-active'));

    if (syncPicker) {
      document.addEventListener('variant:update', pullFromPicker);
      setTimeout(pullFromPicker, 250);
    }
  }
  function boot() { document.querySelectorAll('.bspc').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.bam-pg');
    if (!section) return;
    var tiles = Array.prototype.slice.call(section.querySelectorAll('.bam-pg__tile'));

    // the stock Print dropdown in the buy box (re-rendered on variant updates — query fresh)
    function printSelect() {
      return document.querySelector('.variant-option--dropdowns .variant-option__select');
    }
    function markByVariantId(vid) {
      tiles.forEach(function (t) {
        var s = t.querySelector('.bam-pg__select');
        t.classList.toggle('is-selected', !!s && s.getAttribute('data-variant-id') === vid);
      });
    }
    function syncFromSelect() {
      var sel = printSelect();
      if (!sel) return;
      var o = sel.options[sel.selectedIndex];
      if (o) markByVariantId(o.getAttribute('data-variant-id'));
    }

    // select a variant by id — drives the dropdown (price, photo, marker all follow). Shared by tiles + lightbox.
    function selectByVariantId(vid) {
      var sel = printSelect();
      if (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].getAttribute('data-variant-id') === vid) {
            if (sel.selectedIndex !== i) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); }
            break;
          }
        }
      }
      markByVariantId(vid);
    }
    // gallery click → select (same pattern as the Beespoke crop demo)
    Array.prototype.forEach.call(section.querySelectorAll('.bam-pg__select'), function (btn) {
      btn.addEventListener('click', function () { selectByVariantId(btn.getAttribute('data-variant-id')); });
    });

    // ===== bee-select: enhance the native Print <select> into the Beespoke-style panel =====
    var SIZE_RANK = { tiny: 0, small: 1, medium: 2, large: 3 };
    function cleanLabel(o) { return o.textContent.trim().replace(/\s+-\s+.*$/, ''); }
    function labelParts(label) {
      var w = label.split(/\s+/);
      return { dims: w[w.length - 1], size: (w[w.length - 2] || ''), name: w.slice(0, w.length - 2).join(' ') };
    }
    function closeAllBee() {
      var L = document.querySelectorAll('.bee-select__list');
      for (var i = 0; i < L.length; i++) { L[i].hidden = true; var t = L[i].previousElementSibling; if (t) t.setAttribute('aria-expanded', 'false'); }
    }
    function buildBeeList(sel) {
      var items = [];
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.value === '') return;
        var p = labelParts(cleanLabel(o));
        items.push({ value: o.value, name: p.name, size: p.size, dims: p.dims, rank: (SIZE_RANK[p.size.toLowerCase()] != null ? SIZE_RANK[p.size.toLowerCase()] : 99) });
      });
      var groups = {}, order = [];
      items.forEach(function (it) { if (!groups[it.size]) { groups[it.size] = []; order.push(it); } groups[it.size].push(it); });
      order.sort(function (a, b) { return a.rank - b.rank; });
      var html = '';
      order.forEach(function (g) {
        html += '<li class="bee-select__group" role="presentation">' + g.size + '</li>';
        groups[g.size].forEach(function (it) {
          var on = (it.value === sel.value && sel.value !== '');
          html += '<li class="bee-select__option' + (on ? ' is-selected' : '') + '" role="option"' + (on ? ' aria-selected="true"' : '') +
                  ' data-value="' + String(it.value).replace(/"/g, '&quot;') + '">' + it.name + '&nbsp;&nbsp;' + it.dims + '</li>';
        });
      });
      return html;
    }
    function refreshBee(sel, ui) {
      var valEl = ui.querySelector('.bee-select__value');
      var o = sel.options[sel.selectedIndex];
      var txt = (sel.value && o) ? cleanLabel(o) : 'Pick a Print...';
      if (valEl && valEl.textContent !== txt) valEl.textContent = txt;
      var opts = ui.querySelectorAll('.bee-select__option');
      for (var i = 0; i < opts.length; i++) {
        var on = (opts[i].dataset.value === sel.value && sel.value !== '');
        opts[i].classList.toggle('is-selected', on);
        if (on) opts[i].setAttribute('aria-selected', 'true'); else opts[i].removeAttribute('aria-selected');
      }
    }
    function enhanceBee() {
      var sel = printSelect();
      if (!sel) return;
      var wrapper = sel.closest('.variant-option__select-wrapper') || sel;
      var existing = document.querySelector('.bee-select');
      if (sel.dataset.beeReady === '1' && existing) { refreshBee(sel, existing); return; }
      if (existing) existing.remove();
      wrapper.classList.add('bee-native-hidden');
      sel.dataset.beeReady = '1';
      var ui = document.createElement('div');
      ui.className = 'bee-select';
      ui.innerHTML = '<button type="button" class="bee-select__toggle" aria-haspopup="listbox" aria-expanded="false"><span class="bee-select__value"></span><span class="bee-select__caret" aria-hidden="true"></span></button><ul class="bee-select__list" role="listbox" hidden>' + buildBeeList(sel) + '</ul>';
      wrapper.parentNode.insertBefore(ui, wrapper.nextSibling);
      var toggle = ui.querySelector('.bee-select__toggle'), list = ui.querySelector('.bee-select__list');
      refreshBee(sel, ui);
      toggle.addEventListener('click', function () { var willOpen = list.hidden; closeAllBee(); list.hidden = !willOpen; toggle.setAttribute('aria-expanded', String(willOpen)); });
      list.addEventListener('click', function (e) {
        var li = e.target.closest('.bee-select__option'); if (!li) return;
        sel.value = li.dataset.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        list.hidden = true; toggle.setAttribute('aria-expanded', 'false');
        refreshBee(sel, ui);
      });
    }

    // dropdown / gallery / anything changes the variant → move the 🌼 + refresh the panel
    document.addEventListener('change', function (e) {
      var sel = printSelect();
      if (sel && e.target === sel) {
        syncFromSelect();
        var ui = document.querySelector('.bee-select');
        if (ui) refreshBee(sel, ui);
      }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.bee-select')) closeAllBee(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllBee(); });
    document.addEventListener('variant:update', function () { setTimeout(function () { enhanceBee(); syncFromSelect(); }, 40); });
    enhanceBee();
    syncFromSelect(); // stock behavior: first/URL variant is selected on load — mark it
    var vpEl = document.querySelector('variant-picker');
    if (vpEl && window.MutationObserver) {
      var moBee = false;
      new MutationObserver(function () { if (moBee) return; moBee = true; requestAnimationFrame(function () { moBee = false; enhanceBee(); }); }).observe(vpEl, { childList: true, subtree: true });
    }

    // zoom lightbox
    var lb = section.querySelector('.bam-pg__lightbox');
    var lbImg = section.querySelector('.bam-pg__lb-img');
    var lbCap = section.querySelector('.bam-pg__lb-cap');
    // ordered list of every print (for prev/next navigation inside the lightbox)
    var zoomBtns = Array.prototype.slice.call(section.querySelectorAll('.bam-pg__zoom'));
    var lbItems = zoomBtns.map(function (z) {
      var tile = z.closest('.bam-pg__tile');
      return { src: z.getAttribute('data-zoom'), name: z.getAttribute('data-zoom-name'), vid: tile ? tile.getAttribute('data-variant-id') : null };
    });
    var lbIndex = 0;
    function showLB(i) {
      if (!lbItems.length) return;
      lbIndex = (i + lbItems.length) % lbItems.length;   // wrap around
      var it = lbItems[lbIndex];
      lbImg.src = it.src; lbImg.alt = it.name; lbCap.textContent = it.name;
      if (it.vid) selectByVariantId(it.vid);   // navigating the lightbox actually selects the print
    }
    function openLB(i) { showLB(i); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); }
    function closeLB() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); lbImg.src = ''; }
    zoomBtns.forEach(function (z, i) {
      z.addEventListener('click', function (e) { e.stopPropagation(); openLB(i); });
    });
    section.querySelector('.bam-pg__lb-close').addEventListener('click', closeLB);
    section.querySelector('.bam-pg__lb-prev').addEventListener('click', function (e) { e.stopPropagation(); showLB(lbIndex - 1); });
    section.querySelector('.bam-pg__lb-next').addEventListener('click', function (e) { e.stopPropagation(); showLB(lbIndex + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLB(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLB();
      else if (e.key === 'ArrowLeft') showLB(lbIndex - 1);
      else if (e.key === 'ArrowRight') showLB(lbIndex + 1);
    });

    // motion: staggered rise-in + subtle parallax drift (same family as the Beespoke crop demo)
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      section.classList.add('bam-pg--anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      tiles.forEach(function (t) { io.observe(t); });

      var ticking = false;
      function drift() {
        ticking = false;
        var vh = window.innerHeight;
        tiles.forEach(function (t, i) {
          var r = t.getBoundingClientRect();
          if (r.bottom < -80 || r.top > vh + 80) return;
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          var dir = (i % 3 === 1) ? -1 : 1;
          var pic = t.querySelector('.bam-pg__pic');
          if (pic) pic.style.transform = 'translateY(' + (p * 30 * dir).toFixed(1) + 'px)';
        });
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(drift); }
      }, { passive: true });
      drift();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
